import React, { useCallback, useContext, useRef } from "react";
import styles from "./KindleProgramBenefits.module.scss";
import { recordBehavioralMetric, recordMetricOnce } from "src/utils/metricsUtils";
import WorkflowContext from "src/contexts/WorkflowContext";
import useImpressionCallback from "src/utils/useImpressionCallback";
import focusHelper from "src/utils/focusHelper";
import { getKuBuyingOption } from "src/utils/aapiResponseUtils";
import TranslationsContext from "src/contexts/TranslationsContext";

type PropTypes = {
    item: QuickViewAsinMetadata;
};

const KindleProgramBenefits: React.FC<PropTypes> = ({ item }: PropTypes) => {
    const translations = useContext(TranslationsContext);
    const workflowContext = useContext(WorkflowContext);
    
    const a11yTarget = useRef<HTMLButtonElement>(null);
    const metricsContext = { namespace: "KindleProgramBenefits", qv_asin: item.asin };

    const requestA11yFocus = useCallback(() => {
        focusHelper.requestFocus(a11yTarget.current);
    }, [a11yTarget]);

    useImpressionCallback(a11yTarget, () => recordMetricOnce(metricsContext, `LearnMore.Render`, 1));

    const programBenefits = item.kindleProgramBenefits;
    if (!programBenefits) {
        return null;
    }

    const kuOption = getKuBuyingOption(item.allBuyingOptions);
    const learnMoreString = kuOption?.kindleProgram?.entity?.learnMore?.data?.displayString;
    const additionalDisplayString = kuOption?.callToAction?.entity?.borrow?.data?.additionalDisplayString ?? translations.getText("includes_ebook_and_audiobook");

    if (!learnMoreString || !additionalDisplayString) {
        return null;
    }
    
    const openSheet = () => {
        recordBehavioralMetric(metricsContext, `LearnMore.click`, 1);
        workflowContext.programBenefits({ asin: item.asin, programBenefits: programBenefits }, requestA11yFocus);
    };

    return (
        <div className={`${styles.benefitsText}`} >
            {additionalDisplayString} <button tabIndex={0} ref={a11yTarget} onClick={openSheet}>{learnMoreString}</button>
        </div>
    );
};

export default KindleProgramBenefits;
